import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { useGoogleLogin } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';
import SignInLayer from '../components/SignInLayer';

const Login = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [twoFactorToken, setTwoFactorToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [requiresTwoFactor, setRequiresTwoFactor] = useState(false);
  const [userId, setUserId] = useState(null);
  const { login, loginWithGoogle, verifyTwoFactor, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    console.log('Attempting login...');

    try {
      console.log('Calling login service...');
      const result = await login(email, password, twoFactorToken || null);
      console.log('Login service returned:', result);
      
      if (result && result.requiresTwoFactor) {
        setRequiresTwoFactor(true);
        setUserId(result.userId);
        setTwoFactorToken('');
        setLoading(false);
        return;
      }
      
      if (result && result.token) {
        navigate('/dashboard');
        return;
      }
      
      setError(t('login.invalid_server_response', 'Resposta inválida do servidor'));
      setLoading(false);
    } catch (err) {
      console.error('Login error caught:', err);
      if (err.response?.data?.requiresTwoFactor) {
        setRequiresTwoFactor(true);
        setUserId(err.response.data.userId);
        setTwoFactorToken('');
        setLoading(false);
        return;
      }
      
      setError(err.response?.data?.error || err.response?.data?.message || t('login.login_error', 'Erro ao fazer login'));
      setLoading(false);
    }
  };

  const handleVerifyTwoFactor = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await verifyTwoFactor(userId, twoFactorToken);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || t('login.invalid_verification_code', 'Código de verificação inválido'));
      setLoading(false);
    }
  };

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setLoading(true);
      try {
        await loginWithGoogle(tokenResponse.access_token);
        navigate('/dashboard');
      } catch (err) {
        setError(err.response?.data?.error || t('login.google_login_error', 'Erro ao fazer login com o Google.'));
        setLoading(false);
      }
    },
    onError: () => {
      setError(t('login.google_login_failed', 'Falha no login com o Google.'));
    },
  });

  return (
    <SignInLayer
      email={email}
      setEmail={setEmail}
      password={password}
      setPassword={setPassword}
      twoFactorToken={twoFactorToken}
      setTwoFactorToken={setTwoFactorToken}
      handleSubmit={handleSubmit}
      handleVerifyTwoFactor={handleVerifyTwoFactor}
      handleGoogleLogin={handleGoogleLogin}
      loading={loading}
      error={error}
      requiresTwoFactor={requiresTwoFactor}
      setRequiresTwoFactor={setRequiresTwoFactor}
      setError={setError}
    />
  );
};

export default Login;
